import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, IconButton, Input, InputAdornment, InputLabel, TextField, Typography } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, loginFlagOff, loginWithFacebook, loginWithGoogle } from "../../redux/actions/User";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import Circularbar from "../../components/circularbar/Circularbar";
import { useTranslation } from "react-i18next";
import { baseApi } from "../../api/endpoints";
import { signInWithPopup } from "firebase/auth";
import { fbAuth, provider } from "../../firbaseConfig";
import AuthLayout from "./Layout";
import googleIcon from "../../images/googleIcon.png"

function Login() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { auth, loging, loggedin, logFail, logBlocked, logout, isVerified } = useSelector((state) => state.User);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const [type, setType] = useState(true);

  useEffect(() => {
    if (loggedin) {
      toast.success(t("views.login.loginSuccess"));
      dispatch(loginFlagOff());
    }
    if (logFail) {
      toast.error(t("views.login.invalidCredentials"));
      dispatch(loginFlagOff());
    }
    if (logBlocked) {
      toast.error(t("views.login.userBlocked"));
      dispatch(loginFlagOff());
    }
    if (!isVerified) {
      toast.error(t("views.login.verificationRequired"));
      dispatch(loginFlagOff());
    }
  }, [logFail, logBlocked, loggedin, isVerified]);

  useEffect(() => {
    const isOk = Cookies.get("vcpCredential");
    if (isOk !== undefined) {
      const d = JSON.parse(Cookies.get("vcpCredential"));
      setValue("email", d?.email);
      setValue("password", d?.password);
      setRememberMe(true);
    } else {
      setValue("email", "");
      setValue("password", "");
      setRememberMe(false);
    }
  }, []);

  const onSubmit = (data) => {
    console.log(data);
    dispatch(login(data.email, data.password))
  };

  const onGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(fbAuth, provider);
      if (result) {
        dispatch(loginWithGoogle(result));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkedRememberMe = (e) => {
    const { checked } = e.target;
    if (checked) {
      setRememberMe(true);
      Cookies.set("vcpCredential", JSON.stringify({ email: email, password: password }), { expires: 7 });
    } else {
      Cookies.remove("vcpCredential");
      setRememberMe(false);
    }
  };

  if (auth) {
    return navigate("/");
  }

  return (
    <>
        {loging && (
            <>
                <Box
                    sx={{
                        height: "100vh",
                        width: "100vw",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        zIndex: 10000,
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                    <Circularbar />
                </Box>
            </>
        )}
        <AuthLayout>
            <Typography textAlign="center" maxWidth="460px" variant="h3" sx={{
                color: "#016AFE"
            }}>VCPlayer</Typography>
            <Typography textAlign="center" maxWidth="460px" variant="h4" sx={{
                color: "#313031"
            }}>SIGNAGE</Typography>
            <Button
              variant={"outlined"}
              sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px", width: "40px" }}
              onClick={onGoogleLogin}>
              <img src="/images/googleIcon.png" style={{ height: "100%", width: "100%", objectFit: "contain" }} />
            </Button>
            <form onSubmit={handleSubmit(onSubmit)} noValidate style={{width: '100%', maxWidth: "460px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: "20px",
            }}>
                <TextField
                    {...register("email", {
                    required: true, pattern: {
                      value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: t("views.signup.invalidEmail")
                    }
                    })}
                    onChange={(e) => setEmail(e.target.value)}
                    variant={"standard"}
                    label={t("views.login.email")}
                    type={"email"}
                    fullWidth
                />
                {errors.email && (
                  <Typography sx={{ color: "warning.main" }}>{errors.email?.type == 'required' ? t("views.login.emailRequired") : errors.email.message}</Typography>
                )}
                
                <FormControl variant={"standard"} fullWidth>
                    <InputLabel htmlFor="password">{t("views.login.password")}</InputLabel>
                    <Input
                    id="password"
                    type={type ? "password" : "text"}
                    sx={{ background: "transparent", color: "#313031" }}
                    {...register("password", {
                        required: true,
                        minLength: 6,
                    })}
                    onChange={(e) => setPassword(e.target.value)}
                    endAdornment={
                        <InputAdornment position={"end"} style={{ marginTop: "-10px", color: "#551fff" }}>
                        <IconButton aria-label="toggle password visibility" onClick={() => setType(!type)}>
                            {type ? <VisibilityOffIcon style={{ color: "#551fff" }} /> : <VisibilityIcon style={{ color: "#551fff" }} />}
                        </IconButton>
                        </InputAdornment>
                    }
                    />
                </FormControl>
                {errors.password && (
                  <Typography sx={{ color: "warning.main" }}>{errors.password?.type == 'required' ? t("views.login.passwordRequired") : errors.password?.type == "minLength" ? t("views.login.passToShort") : errors.password.message}</Typography>
                )}

                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%"
                }}>
                    {/* onChange={checkedRememberMe} checked={rememberMe ? true : false} */}
                    <FormGroup>
                      <FormControlLabel control={<Checkbox onChange={checkedRememberMe} checked={rememberMe ? true : false} />} style={{color: "#585858ff"}} label={t("views.login.rememberMe")} />
                    </FormGroup>
                    <Link to={"/forgetpassword"} style={{ textDecoration: "none", color: "#585858ff" }}>
                        {t("views.login.forgetPassword")}
                    </Link>
                </Box>

                <Box>
                    <Button variant="contained" type="submit" fullWidth sx={{
                        "&.Mui-disabled": {
                            background: "#d3d3d3ff",
                            color: "#919191ff"
                        }
                    }}>{t("views.login.login")}</Button>
                </Box>

                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px"
                }}>
                    <Typography sx={{
                      color: "#313031"
                    }}>{t("views.login.noAccount")}</Typography>
                    <Link to={'/signup'} style={{ textDecoration: "none", color: "#016AFE" }}>{t("views.login.createAccount")}</Link>
                </Box>
            </form>
        </AuthLayout>
    </>
  );
}

export default Login;
